import styled from "styled-components";

import { themes } from "@olist/design-system-tokens";

export const AccordionWrapper = styled.div`
  border: 1px solid ${themes.olist.base.color.neutral.softer};
  &:nth-of-type(1) {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  &:nth-last-of-type(1) {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  overflow: hidden;
`;

export const AccordionHeader = styled.div<{ isOpen: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  justify-content: space-between;
  padding: 10px;
`;

export const AccordionContent = styled.div<{ isOpen: boolean }>`
  background-color: #f2f0e9;
  max-height: ${({ isOpen }) => (isOpen ? "auto" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease;
`;

export const Icon = styled.span<{ isOpen: boolean }>`
  margin-right: 10px;
  transform: rotate(${(props) => (props.isOpen ? "180deg" : "0deg")});
  transition: transform 0.3s ease;
`;
